import React from 'react';

import RenderInput from '../../../../../common/components/Form/RenderInput';
import * as rules from '../../../../../common/services/ValidationRules';
import RenderSelect from '../../../../../common/components/Form/RenderSelect';
import { userStatuses } from '../../../../../common/constants/userConstants';

export const dictStatuses = { active: 'ACTIVE', inactive: 'INACTIVE', pending: 'PENDING' };
export const INACTIVE_LABEL = '(Inactive)';

export const failuresSeverities = [
  { value: 'CRITICAL', label: 'Critical' },
  { value: 'NON_CRITICAL', label: 'Non Critical' },
  { value: 'SEMI_CRITICAL', label: 'Semicritical' },
  { value: 'UNDEFINED', label: 'Undefined' },
];

export const failuresErrorTypes = [
  { value: 'Error', label: 'Error' },
  { value: 'Error Blocks All Sessions', label: 'Error Blocks All Sessions' },
  { value: 'Locked Warning', label: 'Locked Warning' },
  { value: 'Warning', label: 'Warning' },
  { value: 'Warning Stops Current Session', label: 'Warning Stops Current Session' },
];

export const failuresErrorTypesWithEmpty = [{ value: '', label: '' }, ...failuresErrorTypes];

export const chargerConditionCreateChildren = () =>
  userStatuses.map((item, i) => {
    const className = `c_condition-label-${item.value.toLowerCase()}`;
    const label = (
      <div key={i}>
        <span className={className} />
        {item.label}
      </div>
    );

    return { value: item.value, label };
  });

export const failuresSeverityChildren = () =>
  failuresSeverities.map((item) => {
    const className = `c_condition-label-${item.value.toLowerCase()}`;
    const label = (
      <div key={item.value}>
        <span className={className} />
        {item.label}
      </div>
    );

    return { value: item.value, label };
  });

export const formFields = [
  {
    name: 'value',
    label: 'Value',
    required: true,
    component: RenderInput,
    validate: [rules.required],
  },
  {
    name: 'status',
    label: 'Status',
    required: true,
    options: chargerConditionCreateChildren(),
    component: RenderSelect,
    validate: [rules.required],
  },
];
